export default __webpack_public_path__ + "static/media/estereofund.01fda8c1.png";